<div *ngIf="showHorizontalDouble" class="gl-chart__double">
  <span class="primary" [ngStyle]="{ width: primaryValue + '%' }"></span>
  <span class="secondary" [ngStyle]="{ width: secondaryValue + '%' }"></span>
</div>
<div *ngIf="showHorizontal" class="gl-chart__basic">
  <span class="gl-chart__basic--item" [ngStyle]="{ width: primaryValue + '%' }"></span>
</div>

<div *ngIf="showCircle" class="gl-chart__circle">
  <div *ngIf="progress && progress <= 0 ? progress : (progress | lmsCheckNoData); else NoDataProgress">
    <div class="gl-chart__circle--gradient" [ngClass]="{ nps: showNPS }"></div>
    <div class="gl-chart__circle--label">
      <span>
        {{ progress | number : '1.0-1' }}
        {{ showPercentage ? '%' : null }}</span
      >
    </div>
    <div
      class="gl-chart__circle--cursor"
      [ngClass]="
        'rotate-' + (primaryValue | calcRotate : [{ nps: showNPS }, { range: maxRange }, chartValue] | number : '1.0-1')
      "
    ></div>
    <div class="gl-chart__circle--canvas">
      <canvas #canvas></canvas>
      <div class="gl-chart__range">
        <span>{{ showNPS ? '-100' : '0' }}</span>
        <span>{{ showMedia ? '10' : '100' }}</span>
      </div>
    </div>
  </div>
  <ng-template #NoDataProgress>
    <div class="gl-chart__circle--void">
      <span>{{ 'dashboard.widgets.metricNoData' | translate }}</span>
    </div>
  </ng-template>
</div>
